import { render, staticRenderFns } from "./PredefinedStyles.vue?vue&type=template&id=6a2f18f4&scoped=true&"
import script from "./PredefinedStyles.vue?vue&type=script&lang=js&"
export * from "./PredefinedStyles.vue?vue&type=script&lang=js&"
import style0 from "./PredefinedStyles.vue?vue&type=style&index=0&id=6a2f18f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2f18f4",
  null
  
)

export default component.exports